import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import TotalGrades from "./TotalGradesComparison";
import CompareMarksAndGrades from "./CompareMarksAndGrades";
import { useState } from "react";
import { useSelector } from "react-redux";
import subjectList from "./subjects.json";
function TotalMarks({ subjects }) {
  const [rankData, setRankData] = useState({});
  const ranks = useSelector((state) => state.rankAnalysis);

  const rank = () => {
  if (subjects && ranks.data && subjectList[subjects]) {
    const subject = subjectList[subjects];

    const result = {
      yourDetails: {
        m: ranks.data.YourDetails[subject.subjectCode],
        c: ranks.data.YourDetails[subject.correct],
        w: ranks.data.YourDetails[subject.wrong],
        u: ranks.data.YourDetails[subject.unAttempted],
      },
      TopperDetails: {
        m: ranks.data.TopperDetails[subject.subjectCode],
        c: ranks.data.TopperDetails[subject.correct],
        w: ranks.data.TopperDetails[subject.wrong],
        u: ranks.data.TopperDetails[subject.unAttempted],
      },
      Average: {
        m: ranks.data.Average[subject.subjectCode],
        c: ranks.data.Average[subject.correct],
        w: ranks.data.Average[subject.wrong],
        u: ranks.data.Average[subject.unAttempted],
      },
      showBranchwiseRank: ranks.data.showBranchwiseRank,
    };

    if (ranks.data.showBranchwiseRank) {
      result.BranchwiseTopperDetails = {
        m: ranks.data.TopperDetailsBranchWise[subject.subjectCode],
        c: ranks.data.TopperDetailsBranchWise[subject.correct],
        w: ranks.data.TopperDetailsBranchWise[subject.wrong],
        u: ranks.data.TopperDetailsBranchWise[subject.unAttempted],
      };

      result.BranchwiseAverage = {
        m: ranks.data.AverageBranchWise[subject.subjectCode],
        c: ranks.data.AverageBranchWise[subject.correct],
        w: ranks.data.AverageBranchWise[subject.wrong],
        u: ranks.data.AverageBranchWise[subject.unAttempted],
      };
    }

    return result;
  }

  return null;
};

  useEffect(() => {
    setRankData(rank);
  }, [ranks, subjects]);
  return (
    <React.Fragment>
      <Grid container direction="column">
        <Grid item xs={12}>
          <CompareMarksAndGrades ranks={rankData} />
        </Grid>
        {/* <Grid item xs={12}>
          <TotalGrades />
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}

export default TotalMarks;
